import CategoriesAdd from "./CategoriesAdd";

export default CategoriesAdd;
